import React from "react";

export const Creative: React.FC = () => {
  return <div>Hello Creative!</div>;
};
